import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-py-md q-mx-auto width-fit"
}
const _hoisted_2 = {
  key: 2,
  class: "scrollable-md"
}

import { StepperListStepProps } from "@/types";
import { Typography, Separator } from "@/components/common/display";


/**
 * Presents a list in a stepper workflow for item selection.
 */
const __default__ = {
  name: "StepperListStep",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {},
    itemCount: {},
    emptyMessage: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Typography), {
      el: "h1",
      variant: "subtitle",
      value: props.title
    }, null, 8, ["value"]),
    _createVNode(_unref(Separator)),
    (props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_circular_progress, {
            indeterminate: "",
            size: "lg"
          })
        ]))
      : _createCommentVNode("", true),
    (props.itemCount === 0 && !props.loading && props.emptyMessage)
      ? (_openBlock(), _createBlock(_unref(Typography), {
          key: 1,
          variant: "small",
          el: "p",
          value: props.emptyMessage
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (!props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})